import React, { Component } from "react";
import { IconButton, Grid, Card, Icon, withStyles } from "@material-ui/core";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import { compose } from "redux";
import ListComponent from "../Common/ListComponent";

import { from } from "apollo-boost";
import { fr } from "date-fns/locale";

const IconSmall = withStyles(() => ({
  root: {
    fontSize: "1.5rem",
    color: "rgba(0, 0, 0, 0.6)",
  },
}))(Icon);

class ProfileRight extends Component {
  state = {
    attachment: null,
    activedatas: [],
    updatelistorder: true,
    company_id:"",
  };

  componentDidMount() {
    let val = { recordtypeid: 3 }
    this.props.getRelatedMasterList(this.props.apolloClient.client, val);
    if(this.props.company_id){
        this.setState({
            company_id:this.props.company_id,
        },()=>{
            this.forceUpdate()
        });
    }
  }
  componentWillReceiveProps(props) {
    if (props.company_id != this.state.company_id) {
          this.setState({
              company_id:parseInt(props.company_id),
          },()=>{
              this.forceUpdate()
          });
    }
    if (props.settingReducer.companyrelatedMaster.data) {
      const companyrelatedMaster = props.settingReducer.companyrelatedMaster.data;
      let activedatas = [];

      companyrelatedMaster.map((fieldData, index) => {
        if (fieldData.isactive === true) {
          activedatas.push({
            key: fieldData.id,
            alias: fieldData.alias,
            isactive: fieldData.isactive,
            orderid: fieldData.orderno,
          });
        }
      });
      if (this.state.updatelistorder == true){
        this.setState({ activedatas: activedatas }, () => this.forceUpdate());
      }
    }
  }

   render() {
      var flag = 0;
      if(window.location.pathname == "/opportunities/opportunities-card" || window.location.pathname == "/opportunities/opportunities-list"){
        flag = 1
      }
      return (
        <>
          <div className="">
            {this.state.company_id && <ListComponent recordId= {this.state.company_id} recordtype={"company"} activedata={this.state.activedatas} allData={this} />}
          </div>
        </>
      );
    }
}
const mapStateToProps = (state) => {
  return {
    settingReducer: state.settingReducer,
    apolloClient: state.apolloClient,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getRelatedMasterList: (client, request) => {
      dispatch(actions.getRelatedMasterList(client, request));
    },
  };
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  ProfileRight
);
